import React from "react";

const TotalAmount = ({ row }) => {
  return (
    <div>
      {row.payments.map((item, index) => (
        <div key={index}>{item.totalAmount?.toLocaleString()}</div>
      ))}
    </div>
  );
};

export default TotalAmount;
